import { getAPIHeaders } from "../app/utils";
import { serverApi } from "../services";

export const postLogin = async (payload) => {
  try {
    const reqOpts = getAPIHeaders();
    const response = await serverApi.post("auth/login", payload, reqOpts);
    return response;
  } catch (error) {
    throw new Error(error.message);
  }
};

export const postVerifyEmail = async (payload) => {
  try {
    const reqOpts = getAPIHeaders();
    const response = await serverApi.post("auth/verify", payload, reqOpts);
    return response;
  } catch (error) {
    throw new Error(error.message);
  }
};

export const postExternalUser = async (payload) => {
  try {
    const reqOpts = getAPIHeaders();
    const response = await serverApi.post("requests", payload, reqOpts);
    return response;
  } catch (error) {
    throw new Error(error.message);
  }
};

export const postLogout = async () => {
  try {
    const reqOpts = getAPIHeaders();
    const response = await serverApi.post("auth/logout", null, reqOpts);
    return response;
  } catch (error) {
    throw new Error(error.message);
  }
};
